
export default {
	ACTIVATE:                        'Activate',
	ACTIVE:                          'Active',
	ADD_CHECKBOX:                    'Checkboxes',
	ADD_COMMUNICATION:               'Add a communication',
	ADD_COMMUNICATION_TUTO:          'Start now by clicking on the button "Add communication".',
	ADD_DROP_DOWN:                   'Dropdown',
	ADD_MARKETER:                    'Add a marketer',
	ADD_MARKETER_TUTO:               'Start now by clicking on the button "Add marketer".',
	ADD_OPTION:                      'Add option',
	ADD_PASS:                        'Add a pass',
	ADD_PASS_TUTO:                   'Start now by clicking on the button "Add a pass".',
	ADD_QUESTION:                    'Add a question of type:',
	ADD_RADIO:                       'Multiple choice',
	ADDRESS:                         'Address',
	ADD_STAR_RATING:                 'Star Rating',
	ADD_STORE:                       'Add a store',
	ADD_SURVEY:                      'Add survey',
	ADD_SURVEY_TUTO:                 'Start now by clicking on the button "Add survey".',
	ADD_TEMPLATE:                    'Create email template',
	ADD_TEMPLATE_NAME:               'Name of the email template',
	ADD_TEMPLATE_TUTO:               'Start now by clicking on the button "Create email template".',
	ADD_TEXT_AREA:                   'Paragraphe',
	ADD_TEXT:                        'Short answer',
	ADD_ZONE:                        'Add zone',
	AGE:                             'Age',
	ALL_COMMENTS:                    'All',
	ALL_RATINGS:                     'All',
	ALL_STORES:                      'All stores',
	ALL_ZONES:                       'All zones',
	ARE_YOU_SURE:                    'Are you sure?',
	AT:                              'at',
	BACK:                            'Back',
	BARCODE:                         'Barcode',
	BG_COLOR:                        'Background color',
	BOUNCED_EMAIL:                   'Bounced/Invalid email addresses',
	BRAND:                           'Brand',
	BRAND_NAME_MANDATORY:            'Brand name is mandatory',
	CANCEL:                          'Cancel',
	CAN_PUBLISH:                     'Can publish',
	CAN_WRITE:                       'Can write',
	CART:                            'Cart',
	CHANGE_PASSWORD:                 'Change password',
	CHECKBOX:                        'Checkboxes',
	CHOOSE_IMAGE:                    'Choose an image',
	COLOR:                           'Color',
	COMMENTS:                        'Comments',
	COMMUNICATION:                   'Communication',
	COMMUNICATIONS:                  'Communications',
	CONDITION_EQUAL:                 'equal (parent)',
	CONDITION_EQUAL_PREVIOUS:        'equal (previous)',
	CONDITION_GREATER_THAN:          'greater than (parent)',
	CONDITION_LOWER_THAN:            'lower than (parent)',
	CONDITION_NO:                    'no condition',
	CONTACT_MID_MANGOOTRUST_TEXT:    'You cannot delete the mangootrust pages. Please contact the hotline',
	CONTACT_MID_MANGOOTRUST_TITLE:   '',
	CONTENT:                         'Content',
	COVER:                           'mangootrust Cover* (16:9 format)',
	CREATE:                          'Create',
	CREATED_AT:                      'Creation date',
	CREATED_BY:                      'Creator',
	CREATE_ZONE:                     'Create zone',
	CURRENT_QUESTIONS:               'Questions',
	CUSTOMERS:                       'Customers',
	DEACTIVATE:                      'Deactivate',
	DEMAT_PERCENTAGE:                'Digitalization percentage',
	DESCRIPTION:                     'Description',
	DESCRIPTION_LOCK:                'Lock screen description',
	DESCRIPTION_MANDATORY:           'Description is mandatory',
	DESIGNATION:                     'Designation',
	DETAIL_INFO:                     'Detail',
	DETAIL:                          'Ratings detail',
	DETAILS:                         'Details',
	DETRACTORS:                      'Detractors',
	DIGITAL_RECEIPT:                 'Digital receipts',
	DONT_DISPLAY:                    'Do not display',
	DOWNLOAD_CLIENT_BASE:            'Download Client Base',
	DOWNLOAD_THE_LIST:               'Download the list',
	DROP_DOWN:                       'Dropdown',
	EDIT:                            'Edit',
	EDIT_ZONE:                       'Edit zone',
	EMAIL_AND_PRINT:                 'Email and print',
	EMAILCOUNT:                      'Number of emails',
	EMAIL_COVER_IMAGE:               'Email cover picture',
	EMAIL_COVER_LINK:                'Email cover link',
	EMAIL:                           'Email',
	EMAIL_MANDATORY:                 'Email is mandatory',
	EMAIL_ONLY:                      'Email only',
	EMAILS:                          'Emails',
	EMAIL_WITHOUT_RECEIPT:           'Email without receipt',
	END_DATE:                        'End Date',
	EXCLUSIVE_OFFER:                 'Exclusive offer',
	FACEBOOK:                        'Facebook',
	FAVORITES:                       'Favorites',
	FG_COLOR:                        'Forground color',
	FOLLOWERS:                       'Followers',
	FORGOT_PASSWORD_QUESTION:        'Forgot password ?',
	GENERAL:                         'General',
	GLOBAL_INFO:                     'Global',
	GLOBAL_RATING:                   'Store rating',
	IMAGE:                           'Image',
	INDICATORS:                      'Indicators',
	INSTAGRAM:                       'Instagram',
	LINKS:                           'Links',
	LOGIN:                           'Sign In',
	LOGO_COVER_EXPLANATION:          '*This cover image will be used in the web pages where the consumer comments will be published (<a href="{{brand.mangootrustUrl}}" target="_blank">{{brand.mangootrustUrl}}</a>).',
	LOGO:                            'Logo*',
	LOGOUT:                          'Logout',
	MANGOOTRUST_LINK:                'mangootrust link',
	MANGOOTRUST:                     'mangootrust',
	MARKETER:                        'Marketer',
	MARKETERS:                       'Marketers',
	MEN:                             'Men',
	NAME_MANDATORY:                  'Name is mandatory',
	NAME:                            'Name',
	NEW_EMAIL:                       'New email',
	NO_COMMUNICATION:                'No communication',
	NO_DATA:                         'No data',
	NO_MARKETER:                     'No marketer',
	NO:                              'No',
	NO_PASS:                         'No pass',
	NO_PRODUCT:                      'No products',
	NO_RECEIPTS:                     'No receipts',
	NO_REVIEW:                       'No review',
	NO_STORE:                        'No store',
	NO_SURVEY:                       'No survey',
	NO_TEMPLATE:                     'No email template',
	NOTES:                           'Products ratings',
	NOTIFICATION_EMAILS_FOR:         'Notifications for',
	NOT_SENT:                        'Generating PDF',
	NPSVALUE:                        'NPS',
	OLD_QUESTIONS:                   'Questions removed',
	OPTOUTS:                         'Opt-outs',
	PASSIVES:                        'Passives',
	PASS:                            'Pass',
	PASSWORD:                        'Password',
	PEOPLE_FOLLOWING_YOUR_BRAND:     'People following your brand',
	PHONE:                           'Phone',
	PICTURE:                         'Picture',
	PINNED_COMMUNICATIONS:           'Pinned communications',
	PINNED_COUNT:                    'Pinned Count',
	POSITION:                        'Position',
	PREFERENCES:                     'Preferences',
	PREVIEW:                         'Preview',
	PRINT_AND_EMAIL:                 'Print and email',
	PRINT_ONLY:                      'Print only',
	PRODUCT_RATING:                  'Product rating',
	PROMOTERS:                       'Promoters',
	PUBLISH_ALL_MANGOOTRUST:         'Publish all stores reviews on www.mangootrust.com',
	PUBLISH_ALL_MANGOOTRUST_TEXT:    'You are about to create pages for your stores on mangootrust, the deletion of these pages will not be permitted',
	PUBLISH_TEMPLATE:                'Publish the email template',
	PUBLISH:                         'Publish',
	PURCHASED_ON:                    'Purchased on',
	QUESTION_ACTIVATE_SURVEY:        'You are about to activate the survey',
	QUESTION_DEACTIVATE_SURVEY:      'You are about to deactivate the survey',
	QUESTION_DELETE_COMMUNICATION:   'You are about to delete the communication',
	QUESTION_DELETE_MARKETER:        'You are about to delete the marketer',
	QUESTION_DELETE_QUESTION:        'You are about to delete the question',
	QUESTION_DELETE_SURVEY:          'You are about to delete the survey',
	QUESTION_DELETE_TEMPLATE:        'You are about to delete the email template',
	QUESTION_DELETE_ZONE:            'You are about to delete the zone',
	QUESTION_SEEN_BY_CUSTOMER:       'Question seen by customers',
	RADIO:                           'Multiple choice',
	RANKING:                         'Ranking',
	RATED_ON:                        'Rated on',
	RATINGAVG:                       'Rating average',
	RATINGCOUNT:                     'Number of ratings',
	RATING_SPLIT:                    'Rating split',
	RATINGS:                         'Ratings',
	READ_COMMUNICATIONS:             'Read communications',
	READ_COUNT:                      'Read Count',
	RECEIPT:                         'Digital receipt',
	RECEIPT_FOOTER_IMAGE:            'Receipt footer image',
	RECEIPT_HEADER_IMAGE:            'Receipt header image',
	REFERENCE:                       'Reference',
	REMOVE_QUESTION:                 'Remove question',
	REMOVE:                          'Remove',
	REMOVE_ZONE:                     'Remove zone',
	REPLIED_ON:                      'Replied on',
	REPLY:                           'Reply',
	REPLY_TO_COMMENT:                'Reply to the comment',
	RESPONSE:                        'Response',
	RESPONSES:                       'Responses',
	REVENUE:                         'Revenue',
	REVIEWS_COUNT:                   'review(s)',
	REVIEWS:                         'Reviews',
	SALE_ON:                         'Purchase made on',
	SAVE:                            'Save',
	SEARCH:                          'Search',
	SENT_COMMUNICATIONS:             'Sent communications',
	SENT:                            'PDF created',
	SETTINGS:                        'Settings',
	SHOW_IN_STORE:                   'To present in store',
	SOME_ZONES:                      'Select zones',
	STAR_RATING:                     'Star Rating',
	START_DATE:                      'Start Date',
	STATS:                           'Report',
	STOREID:                         'Position',
	STORENAME:                       'Name',
	STORES_RATING:                   'Stores rating',
	STORES:                          'Stores',
	STORE:                           'Store',
	SUBJECT:                         'Subject',
	SUMMARY:                         'Summary',
	SUPER:                           'Super',
	SURVEY_CREATION:                 'Survey creation',
	SURVEYS:                         'Surveys',
	SURVEY_STATS:                    'Report for:',
	SURVEY:                          'Survey',
	TAKEN_EMAILS:                    'New emails',
	TEMPLATE:                        'Email template',
	TEMPLATES:                       'Email templates',
	TEXT_AREA:                       'Paragraphe',
	TEXT:                            'Short answer',
	TIMES_YOUR_BRAND_HAS_BEEN_LIKED: 'Times your brand has been liked',
	TITLE:                           'Title',
	TUTORIAL:                        'Tutorial',
	TWITTER:                         'Twitter',
	TYPE:                            'Type',
	UPDATED_AT:                      'Modification date',
	VALID_UNTIL:                     'Valid until',
	VALUE_OF_AVERAGE_CART:           'Value of average cart',
	VIEW_RECEIPT:                    'View receipt',
	VIEW_SURVEY:                     'View survey',
	VISUAL:                          'Visual',
	WEBSITE:                         'Website',
	WITH_COMMENTS_ONLY:              'With comments only',
	WITH_COMMENTS:                   'Yes',
	WITHOUT_COMMENTS:                'No',
	WOMEN:                           'Women',
	WRITE:                           'Write',
	WRITE_YOUR_REPLY:                'Write your reply',
	YES:                             'Yes',
	YOURNOTES:                       'Your products ratings',
	ZONES:                           'Zones',
	ZONE:                            'Zone',
};



// WEBPACK FOOTER //
// ./src/translation/en.js